// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/dashboard/async_request_manager/list_requests" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { dashboardAsyncRequestManagerListRequests } from "./constants";
import type { AsyncRequestManagerListRequestsResult } from "./types";
import { isAsyncRequestManagerListRequestsResult } from "./validators";

export const getAsyncRequestManagerRequests = reactQueryFetcherAdapter(
  dashboardAsyncRequestManagerListRequests,
  (
    signal: AbortSignal,
    appGroupId: string,
    useCase: string,
    page?: number,
    perPage?: number,
    segmentId?: string,
    entityId?: string,
    entityType?: "segment" | "campaign" | "canvas"
  ): Promise<AsyncRequestManagerListRequestsResult> => {
    // remove segmentId param when deprecating FF "generic_async_request_params"
    return fetch(
      "/dashboard/async_request_manager/list_requests",
      "GET",
      {
        app_group_id: appGroupId,
        use_case: useCase,
        page,
        per_page: perPage,
        segment_id: segmentId,
        entity_id: entityId,
        entity_type: entityType,
      },
      { signal }
    );
  },
  isAsyncRequestManagerListRequestsResult
);
